module.exports = __webpack_public_path__ + "img/TORBA2.571962e5.jpg";